import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useState } from "react";
import getBase64 from "../../../../utils/getBase64";
import postDataClaim from "../../../../services/postDataClaim";
import { useQueryClient } from "@tanstack/react-query";

export default function CreateFirm({ isVisible, hideModal }: any) {
  const [isLoading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState();

  const [form] = Form.useForm();

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const onSubmit = async () => {
    setLoading(true);
    const { name, website, address1, address2, address3, address4 } =
      await form.getFieldsValue();
    let base64 = null;
    if (selectedFile) {
      base64 = await getBase64(selectedFile);
    }
    const data = {
      isActive: true,
      name,
      logo: base64,
      website,
      address1,
      address2,
      address3,
      address4,
    };
    const uri = `firms`;
    const response = await postDataClaim(data, uri);
    if (response.success) {
      message.success("Created Successfully");
      queryClient.invalidateQueries({ queryKey: ["firms"] });
      form.resetFields();

      hideModal();
    } else {
      message.error(response.message);
    }
    setLoading(false);
  };

  const clearForm = async () => {
    form.resetFields();
    setLoading(false);
  };

  return (
    <Modal
      open={isVisible}
      title="New Company"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createFirm"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createFirm"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Company Name"
              rules={[
                {
                  required: true,
                  message: "Please enter company name",
                },
              ]}
            >
              <Input placeholder="Company name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="website"
              label="Company Website"
              rules={[
                {
                  required: true,
                  message: "Please enter website",
                },
              ]}
            >
              <Input placeholder="Company Website" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address1"
              label="Address 1"
              rules={[
                {
                  required: true,
                  message: "Please enter address 1",
                },
              ]}
            >
              <Input placeholder="Address 1" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address2"
              label="Address 2"
              rules={[
                {
                  required: true,
                  message: "Please enter address 2",
                },
              ]}
            >
              <Input placeholder="Address 2" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address3"
              label="Address 3"
              rules={[
                {
                  required: true,
                  message: "Please enter address 3",
                },
              ]}
            >
              <Input placeholder="Address 3" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address4"
              label="Address 4"
              rules={[
                {
                  required: true,
                  message: "Please enter address 4",
                },
              ]}
            >
              <Input placeholder="Address 4" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="file"
              label="Company Logo"
              rules={[
                {
                  required: false,
                  message: "Please select file",
                },
              ]}
            >
              <Input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                placeholder="Document"
                onChange={changeHandler}
              />
            </Form.Item>
            {isSelected && <div className="text-sm text-green-500">File selected</div>}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
